import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "checkbox"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.contentTarget.classList.remove("d-none")
    } else {
      this.contentTarget.classList.add("d-none")
    }
  }
}
